export default __webpack_public_path__ + "static/media/1.31b76267.png";